import * as React from 'react';
import { Table } from "soprasteria-ui-library";
import { IOrthodonticLkgCfPatient } from '../../../models/IOrthodonticLkgCfPatient';
import { Link } from 'react-router-dom';
import { PATIENT } from '../../../utils/RouteConstants';
import { dateTimeToDateString } from '../../../helpers/DateHelper';
import { formatPersonalSecurityNumberAndOrganisationNumber } from "../../../helpers/PersonalSecurityNumberAndOrganisationNumberHelper";

interface IOrthodonticLkgCfPatientsTable {
    orthodonticLkgCfPatients: IOrthodonticLkgCfPatient[];
}

export const OrthodonticLkgCfPatientsTable: React.FunctionComponent<IOrthodonticLkgCfPatientsTable> = ({ orthodonticLkgCfPatients }) => {
    const renderTableLink = (linkText: string, patientGuidId: string) => {
        return <Link to={`${PATIENT}/${patientGuidId}`}>{linkText}</Link>
    }

    return (
        <Table hoverableRows>
            <thead>
                <tr>
                    <th>Personnummer</th>
                    <th>Namn</th>
                    <th>Startdatum</th>
                    <th>Slutdatum</th>
                    <th>Typ</th>
                    <th>Status</th>
                </tr>
            </thead>
            <tbody>
                {
                    orthodonticLkgCfPatients.length > 0 ?
                        orthodonticLkgCfPatients.map((orthodonticLkgCfPatient, key) =>
                            <tr key={key} className="clickable-row">
                                <td className="table-data-link">{renderTableLink(formatPersonalSecurityNumberAndOrganisationNumber(orthodonticLkgCfPatient.patientPersonalSecurityId), orthodonticLkgCfPatient.patientGuidId)}</td>
                                <td className="table-data-link">{renderTableLink(orthodonticLkgCfPatient.patientName, orthodonticLkgCfPatient.patientGuidId)}</td>
                                <td className="table-data-link">{renderTableLink(dateTimeToDateString(orthodonticLkgCfPatient.lkgCfStartedDate), orthodonticLkgCfPatient.patientGuidId)}</td>
                                <td className="table-data-link">{renderTableLink(orthodonticLkgCfPatient.lkgCfEndedDate ? dateTimeToDateString(orthodonticLkgCfPatient.lkgCfEndedDate) : "", orthodonticLkgCfPatient.patientGuidId)}</td>
                                <td className="table-data-link">{renderTableLink(orthodonticLkgCfPatient.orthodonticLkgCfPatientType, orthodonticLkgCfPatient.patientGuidId)}</td>
                                <td className="table-data-link">{renderTableLink(orthodonticLkgCfPatient.orthodonticLkgCfPatientStatus, orthodonticLkgCfPatient.patientGuidId)}</td>
                            </tr>
                        )
                        : <tr><td colSpan={6}>Hittade inga registrerade patienter</td></tr>
                }
            </tbody>
        </Table>
    )
}